const isDateCode = `import { isDate } from 'cristatus';

const isDate = isDate(new Date()); //true
`;

export default isDateCode;
